<!-- 全景数据展板 -->
<template>
  <div class="panorama-data-board">
    <div class="panorama-data-board-left">
        <!-- 教师备授课活跃排行top10 -->
        <active-rank></active-rank>
        <!-- 教师备授课行为分析 -->
        <behavior-analysis></behavior-analysis>
        <!-- 精准教学 -->
        <precision-teach></precision-teach>
    </div>
    <div class="panorama-data-board-content">
        <region-number-info></region-number-info>
        <!-- 地图及旋转 -->
        <region-map></region-map>
    </div>
    <div class="panorama-data-board-right">
        <!-- 资源概况 -->
        <resource-info></resource-info>
        <!-- 教研概况 -->
        <teach-overview></teach-overview>
    </div>
  </div>
</template>
<script>
import ActiveRank from "@/views/site/modules/ActiveRank.vue"
import BehaviorAnalysis from "@/views/site/modules/BehaviorAnalysis.vue"
import PrecisionTeach from "@/views/site/modules/PrecisionTeach.vue"
import ResourceInfo from "@/views/site/modules/ResourceInfo.vue"
import TeachOverview from "@/views/site/modules/TeachOverview.vue"
import RegionNumberInfo from "@/views/site/modules/RegionNumberInfo.vue"
import RegionMap from "@/views/site/modules/RegionMap.vue"

export default {
  name: 'panorama',
  components:{
    ActiveRank,
    BehaviorAnalysis,
    PrecisionTeach,
    ResourceInfo,
    TeachOverview,
    RegionNumberInfo,
    RegionMap
  },
  data() {
    return {
    }
  },
  methods: {

  },
  watch: {

  },
  computed: {

  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
 @font-face {
    font-family: DigifaceWide;
    src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
}
.panorama-data-board{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  width: 100%;
  .panorama-data-board-left{
    width: calc(25% - 10px);
  }
  .panorama-data-board-content{
    width: calc(50% - 20px);
  }
  .panorama-data-board-right{
    width: calc(25% - 10px);
  }
}

</style>